import React, { useEffect, useState } from 'react';
import { adminApi } from '../services/api';

const MarkupSettings = () => {
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchSettings = async () => {
      setLoading(true);
      try {
        const data = await adminApi.getSettings();
        setSettings(data);
      } catch (err) {
        setError('Failed to load settings');
      } finally {
        setLoading(false);
      }
    };
    fetchSettings();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setSettings((prev) => ({
      ...prev,
      markup: {
        ...prev.markup,
        [name]: value,
      },
    }));
  };

  const handleSave = async () => {
    setSaving(true);
    setError(null);
    try {
      await adminApi.updateSettings(settings);
    } catch (err) {
      setError('Failed to save settings');
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <div>Loading markup settings...</div>;
  if (!settings) return <div>No settings found.</div>;

  return (
    <div className="bg-white shadow rounded-lg p-6 max-w-lg mx-auto">
      <h2 className="text-xl font-bold mb-4">Markup Settings</h2>
      <div className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700">Enabled</label>
          <select
            name="enabled"
            value={settings.markup?.enabled ? 'true' : 'false'}
            onChange={e => handleChange({ target: { name: 'enabled', value: e.target.value === 'true' } })}
            className="mt-1 block w-full border-gray-300 rounded-md"
          >
            <option value="true">Enabled</option>
            <option value="false">Disabled</option>
          </select>
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700">Type</label>
          <select
            name="type"
            value={settings.markup?.type || ''}
            onChange={handleChange}
            className="mt-1 block w-full border-gray-300 rounded-md"
          >
            <option value="percentage">Percentage</option>
            <option value="fixed">Fixed</option>
          </select>
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700">Value</label>
          <input
            type="number"
            name="value"
            value={settings.markup?.value || ''}
            onChange={handleChange}
            className="mt-1 block w-full border-gray-300 rounded-md"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700">Minimum Markup</label>
          <input
            type="number"
            name="minimumMarkup"
            value={settings.markup?.minimumMarkup || ''}
            onChange={handleChange}
            className="mt-1 block w-full border-gray-300 rounded-md"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700">Rounding Rule</label>
          <select
            name="roundingRule"
            value={settings.markup?.roundingRule || ''}
            onChange={handleChange}
            className="mt-1 block w-full border-gray-300 rounded-md"
          >
            <option value="up">Up</option>
            <option value="down">Down</option>
            <option value="nearest">Nearest</option>
          </select>
        </div>
      </div>
      {error && <div className="text-red-500 mt-2">{error}</div>}
      <button
        onClick={handleSave}
        disabled={saving}
        className="mt-6 px-4 py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-700 disabled:opacity-50"
      >
        {saving ? 'Saving...' : 'Save Markup Settings'}
      </button>
    </div>
  );
};

export default MarkupSettings;
